import { ReactNode } from "react";
import { cn } from "@/shared/lib/utils";

interface SectionBlockProps {
  children: ReactNode;
  className?: string;
  color?: string;
  /** Use glass (translucent blur) background. Default is solid white. */
  glass?: boolean;
}

export function SectionBlock({
  children,
  className,
  color = "var(--help)",
  glass = false,
}: SectionBlockProps) {
  return (
    <div
      className={cn(glass ? "glass-panel" : "solid-panel", className)}
      style={{
        border: `1px solid ${color}`,
      }}
    >
      {children}
    </div>
  );
}
